import React from 'react';
import { StyledFlagshipLabel, StyledFlagshipLabelWrapper } from './styles';

const DS_FlagshipLabel = ({ label, shouldUseLabel, isLocationFlagship, $impressClinic }) => {
  if (!shouldUseLabel || !isLocationFlagship) return;

  return (
    <StyledFlagshipLabelWrapper>
      <StyledFlagshipLabel $impressClinic={$impressClinic} variant="DS_labelSmallBold" component="div">
        {label || 'Flagship'}
      </StyledFlagshipLabel>
    </StyledFlagshipLabelWrapper>
  );
};

export default DS_FlagshipLabel;
